import { Button, Carousel, CarouselItem, Container } from "reactstrap";
import adventureEventBg from "../../assets/adventure-event-bg.png";
import Header from "../../components/globals/Header";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import ResturantBasicDetails from "../../components/page-sections/ResturantBasicDetails";
import {
  IoArrowBackOutline,
  IoArrowForwardOutline,
  IoFemale,
  IoMaleOutline,
} from "react-icons/io5";
import ResturantsDiscountsDetail from "../../components/page-sections/ResturantsDiscountsDetail";
import ResturantGalleryDetails from "../../components/page-sections/ResturantGalleryDetails";
import ResturantReviews from "../../components/page-sections/ResturantReviews";
import BookLet from "../../components/specials/BookLet";
import ResturantSpecialEvent from "../../components/page-sections/ResturantSpecialEvent";

const AdventureEventDetails = () => {
  const { state } = useLocation();

  //other details are sent here
  const slideItems = [
    <ResturantBasicDetails details={state} />,
    <ResturantsDiscountsDetail details={state} />,
    <ResturantGalleryDetails details={state} />,
    <ResturantSpecialEvent details={state} />,
    <ResturantReviews />,
  ];
  //

  return (
    <div>
      <Container fluid>
        <Header title={"My Places"} />
        <div className="bg-white d-flex py-2 px-3  mb-4 align-items-center justify-content-between full-width">
          <h5 className="f-6 color-primary-blue m-0">
            {state?.title}{" "}
            {state?.genderType === "male" ? (
              <IoMaleOutline size={30} color="blue" />
            ) : (
              <IoFemale size={30} color="rgb(157, 1, 85)" />
            )}
          </h5>
          <Button className="standard-rounded-btn  py-2 inner-shadow-white">
            Close
          </Button>
        </div>
        <BookLet pageBackground={adventureEventBg} title={state?.title}>
          {slideItems?.map((item, key) => item)}
        </BookLet>
      </Container>
    </div>
  );
};

export default AdventureEventDetails;
